import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { vehicleService } from "../../../../services/vehicleService";
import { useCustomToast } from "components/CustomToast/CustomToast";
import { generatePrintNoRecordHtml } from "./Templates/PrintNoRecordTemplate";
import { useTranslation } from "react-i18next";
import { ROUTES } from "constants/routes-path";

const NoRecordPrint = () => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const plate = searchParams.get("placa");
    const [html, setHtml] = useState(null);
    const showToast = useCustomToast();
    const navigate = useNavigate();
  
    const fetchData = async () => {
        try {
            const data = await vehicleService.printNoRecord(plate);
            const htmlContent = await generatePrintNoRecordHtml(data);
            setHtml(htmlContent);
        } catch (err) {
            showToast({ title: t(err), status: "error" });
            navigate(ROUTES.trafficViolationsPath)
        }
    };

    useEffect(() => {
        fetchData();
    }, [plate]);

    useEffect(() => {
        if (html) {
            document.body.innerHTML = html;
        }
    }, [html]);

  return null;
};

export default NoRecordPrint;
